import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';
import { GetSimpleFooterResponse } from './types';

export const getSimpleFooter = async (lang = 'en') => {
	return fetch(`${PUBLIC_IDM_API_URL_ENV}/nav/footer?culture=${lang}`, {
		method: 'GET',
	})
	.then((res) => {
		if (res.ok) return res.json() as Promise<GetSimpleFooterResponse>;
	})
	.catch((error) => {
		console.error('Get footer request error: ', error);
		throw error;
	});
};
